export const en = {
  form: {
    title: 'title',
    avatarUrl: 'avatarUrl',
    operateDate: 'operateDate',
    operationType: 'operationType'
  }
}